module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discover flex flex-column flex-1"
  }, [_c('u-header', [_vm._v("发现美好事物")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scrollable container flex-1 flex flex-row"
  }, [_c('p', [_vm._v("开发中")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73560fb4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Discover.vue
// module id = 201
// module chunks = 5